/**
 * Compra de packs por asistentes de IA.
 * El botón del pack (app Crioh Packs) añade al carrito con su propio fetch a
 * /cart/add.js. Aquí se emite el evento estándar del carrito
 * (shopify:cart:lines-update, CartLinesUpdateEvent) alrededor de esa petición,
 * para que un agente sepa que el pack se ha añadido y con qué carrito.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const originalFetch = window.fetch.bind(window);

function packPayload(input, init) {
  const url = typeof input === 'string' ? input : input && input.url;
  if (!url || !/\/cart\/add(\.js)?(\?|$)/.test(url)) return null;
  if (!init || String(init.method || '').toUpperCase() !== 'POST' || typeof init.body !== 'string') return null;
  try {
    const body = JSON.parse(init.body);
    const items = (body.items || []).filter((item) => item.properties && item.properties._pack_id);
    return items.length ? items : null;
  } catch (e) {
    return null;
  }
}

window.fetch = function (input, init) {
  const items = packPayload(input, init);
  if (!items) return originalFetch(input, init);

  const deferred = CartLinesUpdateEvent.createPromise();
  const target = document.querySelector('.crioh-pack-buy__btn') || document;
  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({
        merchandiseId: `gid://shopify/ProductVariant/${String(item.id).split('/').pop()}`,
        quantity: Number(item.quantity) || 1,
      })),
      promise: deferred.promise,
    })
  );

  const request = originalFetch(input, init);
  request
    .then((response) => {
      if (!response.ok) throw new Error('cart/add ' + response.status);
      return originalFetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    })
    .then((response) => response.json())
    .then((cart) =>
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { source: 'crioh-pack-buy', items: cart.items, didError: false },
      })
    )
    .catch(deferred.reject);
  return request;
};
